import React from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";



const CustomSkinMap = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      defaultZoom={3}
      defaultCenter={{lat: 39.7392358, lng: -95.990251}}
      defaultOptions={{
        scrollwheel: true,
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        styles: [
          // {
          //   featureType: 'all',
          //   elementType: 'geometry.fill',
          //   stylers: [{ color: "#340312" }]
          // },
          // {
          //   featureType: "water",
          //   stylers: [
          //     { saturation: 43 },
          //     { lightness: -11 },
          //     { hue: "#0088ff" }
          //   ]
          // },
          // {
          //   featureType: "road",
          //   elementType: "geometry.fill",
          //   stylers: [
          //     { hue: "#9b1b2e" },
          //     { saturation: 0 },
          //     { lightness: 0 }
          //   ]
          // },
          // {
          //   featureType: "road",
          //   elementType: "geometry.stroke",
          //   stylers: [{ color: "#9b1b2e" }, { lightness: 10 }]
          // },
          // {
          //   featureType: "landscape.man_made",
          //   elementType: "geometry.fill",
          //   stylers: [{ color: "#340312" }]
          // },
          // {
          //   featureType: "poi.park",
          //   elementType: "geometry.fill",
          //   stylers: [{ color: "#340312" }]
          // },
          // {
          //   featureType: "road",
          //   elementType: "labels.text.fill",
          //   stylers: [{ color: "#767676" }]
          // },
          // {
          //   featureType: "road",
          //   elementType: "labels.text.stroke",
          //   stylers: [{ visibility: "off" }, { color: "#ffffff" }]
          // },
          // { featureType: "poi", stylers: [{ visibility: "off" }] },
          // {
          //   featureType: "landscape.natural",
          //   elementType: "geometry.fill",
          //   stylers: [{ visibility: "on" }, { color: "#7a102d" }]
          // },
          // { featureType: "poi.park", stylers: [{ visibility: "on" }] },
          // {
          //   featureType: "poi.sports_complex",
          //   stylers: [{ visibility: "on" }]
          // },
          // { featureType: "poi.medical", stylers: [{ visibility: "on" }] },
          // {
          //   featureType: "poi.business",
          //   stylers: [{ visibility: "simplified" }]
          // }
        ]
      }}
    >
        {console.log(props)}
        
{
                props.vehicles ? props.vehicles.map((vehicle) => (
                        <Marker
                            position={{ lat: vehicle.vehicle.current_location.lat, lng: vehicle.vehicle.current_location.lon }}
                            // onClick={() => onMarkerClick(vehicle.vehicle.id)}
                            icon="https://firebasestorage.googleapis.com/v0/b/freightdragons.appspot.com/o/logos%2Fcargorx-icon-small.png?alt=media&token=e716edb3-243c-4c18-a323-1322f36cfe5d"
                        />
                )) :
                <Marker 
        position={props.driverCoords} 
        icon="https://firebasestorage.googleapis.com/v0/b/freightdragons.appspot.com/o/logos%2Fhaneyorb.png?alt=media&token=705c013d-a2af-44b3-af69-8f14f2007b73"
        />
            }
        <Marker position={props.originCoords} />
        <Marker position={props.destinationCoords} />
    </GoogleMap>
  )) 
);

function FullScreenMap({ ...prop }) {
    // console.log(prop)

    
    
  return (
    <CustomSkinMap
      googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBE8t4cZOiXveVFhFl18cYuQiziblthdsY"
      loadingElement={<div style={{ height: `100%` }} />}
      containerElement={<div style={{ height: `25vh` }} />}
      mapElement={<div style={{ height: `100%` }} />}
      originCoords={prop.originCoords}
      destinationCoords={prop.destinationCoords}
      vehicles={prop.vehicles}
      driverCoords={prop.driverCoords}

    />
  );
}

export default FullScreenMap;



// WEBPACK FOOTER //
// ./src/views/Maps/ShipFullScreenMap.jsx